<template>
  <slice
    :id="block._key"
    class="slice--spacing"
    :class="[
      `spacing--${block.level}`,
      `spacing--desktop--${block.level_desktop}`,
    ]"
    :detect-in-screen="false"
  ></slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'

export default {
  name: 'BlockSpacing',
  components: {
    Slice,
  },
  props: { block: { type: Object, required: true } },
}
</script>

<style lang="scss">
.spacing {
  @include mq($until: tablet) {
    &--simple {
      height: calc(var(--spacing) * 2);
    }

    &--double {
      height: calc(var(--spacing) * 4);
    }

    &--triple {
      height: calc(var(--spacing) * 6);
    }

    &--none {
      height: 0;
    }
  }

  @include mq($from: tablet) {
    &--desktop {
      &--simple {
        height: calc(var(--spacing) * 2);
      }

      &--double {
        height: calc(var(--spacing) * 4);
      }

      &--triple {
        height: calc(var(--spacing) * 6);
      }

      &--none {
        height: 0;
      }
    }
  }
}
</style>
